import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Navbar from './Navbar/index.js';
import Search from './Search/index.js';
import Header from './Header/index.js';
import Cart from './Cart/index.js';
import Blog from './Blog/index.js';
import ProductStickyBar from './ProductStickyBar.js';
import Toast from './Toast/index.js';
import PopinNewsletter from './PopinNewsletter.js';
import ProductInfo from './ProductInfo/index.js';

/**
 * Shop component
 */
export default class Shop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Shop',
    components: {
      PopinNewsletter,
      Header,
      Navbar,
      Cart,
      ProductStickyBar,
      Search,
      Blog,
      Toast,
      ProductInfo,
      Facets: (app) => importWhenVisible(() => import('./Facets/index.js'), 'Facets', app),
      VariantMedia: (app) =>
        importWhenVisible(() => import('./VariantMedia.js'), 'VariantMedia', app),
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}
